// Organic banner distribution: one banner every 8–10 items (pseudo-random gap
// from a seed), never the same banner twice in a row, never two slots glued.
function rng(seed) {
  let s = (Number(seed) || 1) % 2147483647;
  if (s <= 0) s += 2147483646;
  return () => (s = (s * 16807) % 2147483647) / 2147483647;
}

export function planBannerSlots(count, banners, seed = 1, { minGap = 8, maxGap = 10 } = {}) {
  const slots = {};
  if (!banners?.length || count < minGap) return slots;
  const rand = rng(seed);
  const pool = [...banners].sort(() => rand() - 0.5);
  let pos = minGap - 1 + Math.floor(rand() * (maxGap - minGap + 1));
  let k = 0;
  let last = null;
  while (pos < count) {
    let b = pool[k % pool.length];
    if (pool.length > 1 && b.id === last) { k += 1; b = pool[k % pool.length]; }
    slots[pos] = b;
    last = b.id;
    k += 1;
    pos += minGap + Math.floor(rand() * (maxGap - minGap + 1));
  }
  return slots;
}
